import { render, staticRenderFns } from "./CargoManager.vue?vue&type=template&id=181d4edd&scoped=true&"
import script from "./CargoManager.vue?vue&type=script&lang=js&"
export * from "./CargoManager.vue?vue&type=script&lang=js&"
import style0 from "./CargoManager.vue?vue&type=style&index=0&id=181d4edd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d4edd",
  null
  
)

export default component.exports